import PlaceholderPage from '../components/PlaceholderPage';

export default function Nadis() {
  return (
    <PlaceholderPage
      title="NADIS"
      description="The National Animal Disease Information System page lands here."
    />
  );
}
